import styled from 'styled-components/macro';

export const WizardSummary = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
